export enum BrowserMessageType {
  GetLinkedInProfile = "GetLinkedInProfile",
  GetEmail = "GetEmail",
  HighlightKeywords = "HighlightKeywords",
  Login = "Login",
  PlatformSignOut = "PlatformSignOut",
  ExtensionSignOut = "ExtensionSignOut",
  ShowAction = "ShowAction",
  UpdateSequencerAuthStatus = "UpdateSequencerAuthStatus",
  ReloadSequencerAuthStatus = "ReloadSequencerAuthStatus",
  ShowTab = "ShowTab",
  ImportProgressError = "ImportProgressError",
  ReloadContentScript = "ReloadContentScript",
  ReloadContentScripts = "ReloadContentScripts",
  LoginGmail = "LoginGmail",
  LoginMicrosoft = "LoginMicrosoft",
  LookUpLinkedInGeoLocation = "LookUpLinkedInGeoLocation",
  ConnectAts = "ConnectAts",
  UpdateAtsIntegrationStatus = "UpdateAtsIntegrationStatus",
  ReloadAtsIntegrationStatus = "ReloadAtsIntegrationStatus",
  DisconnectAts = "DisconnectAts",
  ActiveTabChangedTracking = "ActiveTabChangedTracking",
  FetchUrl = "FetchUrl",
  disableScrolling = "disableScrolling",
  enableScrolling = "enableScrolling",
  Ping = "TomboPing",
  Pong = "TomboPong",
  ImportProgressUpdate = "ImportProgressUpdate",
  SaveDefaultVertical = "SaveDefaultVertical",
  GetDefaultVertical = "GetDefaultVertical",
  SelectVacancy = "SelectVacancy",
  RequestReloadVacancy = "RequestReloadVacancy",
  ReloadVacancy = "ReloadVacancy",
  ReloadBillingStatus = "ReloadBillingStatus",
  GetExtensionStatus = "GetExtensionStatus",
  ExtensionStatus = "ExtensionStatus",
  GotExtensionStatus = "GotExtensionStatus",
  AuthenticateWithToken = "AuthenticateWithToken",
  RestoreLastActiveTab = "RestoreLastActiveTab",
  CloseTab = "CloseTab",
  ProcessLiJobPosting = "ProcessLiJobPosting",
  ImportLiSearch = "ImportLiSearch",
  ReloadTomboTabs = "ReloadTomboTabs",
  SendLinkedInConnectionRequest = "SendLinkedInConnectionRequest",
  CachePageText = "CachePageText",
  GetExtensionEnabledUrls = "GetExtensionEnabledUrls",
  SetExtensionEnabledUrls = "SetExtensionEnabledUrls",
  GetFeatureFlags = "GetFeatureFlags",
  LoginFailedForDisabledUser = "LoginFailedForDisabledUser",
}

/**
 * Types that can be sent over a port directly to the extension
 * as opposed to being broadcast.
 */
export type SecureBrowserMessageType = BrowserMessageType.AuthenticateWithToken

export interface BrowserMessage {
  message: BrowserMessageType
  [k: string]: any
}

export interface SecureBrowserMessage extends BrowserMessage {
  message: SecureBrowserMessageType
}
